/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CanvasCourseIdCopyingEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('CANVAS_COURSE_ID_COPYING_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CanvasCourseIdCopyingEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CanvasCourseIdCopyingEnabledSettingParser.decode(input).map(res => new CanvasCourseIdCopyingEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return CanvasCourseIdCopyingEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CanvasCourseIdCopyingEnabledSettingParser.encode(data);
    }
    static schema() {
        return CanvasCourseIdCopyingEnabledSettingParser.schema();
    }
}
